import React from 'react';
import { dateTimeOptions } from '../../utils/dates';

const HydrantFlushTableRow = ({ flush, onSelect }) => {
  const formatDate = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', dateTimeOptions);
  };

  return (
    <tr id={flush.id}>
      <td>{formatDate(flush.startDate)}</td>
      <td>{formatDate(flush.endDate)}</td>
      <td>{flush.gallonsUsed ?? ''}</td>
      <td>{flush.flowDevice?.name ?? ''}</td>
      <td className="actions">
        <div className="link" onClick={() => onSelect(flush.id)}>Select</div>
      </td>
    </tr>
  );
};

export default HydrantFlushTableRow;
